import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-navigations/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import TreeNodeDropdown from '../../common/DropdownMenus/TreeNodeDropdown';
import AlertDialog from '../../common/AlertDialog';

let userDetails = getLocalStorageVariables();
const linkArr = [{
    icon:"link",
    label:"Link this clause"
}];

class FrameworkLinkClauseDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,
            componentDidMountFlag:false,
            detailFramworkIndex:{},
            oldDetailFrameworkIndex:{},
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            showFrameworkClauseDialog:false
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showLinkDialog){
            this.setState({
                showLoader:false,
                componentDidMountFlag:false,
                detailFramworkIndex:{},
                oldDetailFrameworkIndex:{},
                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
                showFrameworkClauseDialog:false
            },()=>{
                this.getIndexLevelFramework();
            })
        }
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Handles the selection of an item from the dropdown menu.
    onDropDownItemClick = (item,frameworkObj) => {
        if(item.label === "Link this clause"){
            this.setState({
                showFrameworkClauseDialog:true,
                frameworkId2:this.props.rootFrameworkId,
                frameworkClauseId2:frameworkObj.frameworkClauseId
            },()=>{
                this.frameworkLink();
            })
        }
    }

    // Handle root framework dialog close event
    handleRootFrameworkDialogClose = () => {
        this.setState({
            showFrameworkClauseDialog:false,
        })
    }

    // Handles node expansion in the tree view.
    nodeDetailExpanded = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: true };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }

    // Handles node collapse in the tree view.
    nodeDetailCollapsed = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: false };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }

    // Handles node expanding event in the details framework tree, fetching child data if available.
    handleDetailsNodeExpanding = async (args) => {
        const nodeData = args.nodeData;
        if (nodeData.hasChildren) {
            this.getChildFramework(nodeData.id);
        }
    }

    // Updates tree data by recursively traversing the node list.
    updateTreeDataWithChildren = (list, frameworkClauseId, childNodes) => {
        return list.map(node => {
            if (node.frameworkClauseId == frameworkClauseId) {
                // Update the node's child nodes and set its expanded state to true.
                return { ...node, child: childNodes, expanded: true };
            }

            // If node has children, recursively update their data
            if (node.child && node.child.length > 0) {
                // Recursively call the updateTreeDataWithChildren function on the node's children
                const updatedChildren = this.updateTreeDataWithChildren(node.child, frameworkClauseId, childNodes);

                // Check if any child is expanded, then keep this node expanded
                const isAnyChildExpanded = updatedChildren.some(child => child.expanded);

                // Update the node's child nodes and set its expanded state based on its children's expanded state
                return {
                    ...node,
                    child: updatedChildren,
                    expanded: isAnyChildExpanded // Keep this node expanded if any child is expanded
                };
            }

            // Collapse other nodes.
            return { ...node, expanded: false };
        });
    };

    // Finds a node by frameworkClauseId in a tree and returns it with its parents.
    findNodeWithParents = (nodes, frameworkClauseId) => {
        for (const item of nodes) {
            // Check if the current item has the matching frameworkClauseId
            if (item.frameworkClauseId == frameworkClauseId) {
                return [item];
            }
            // If the item has children, search within the child array
            if (item.hasChildren && item.child.length > 0) {
                const result = this.findNodeWithParents(item.child, frameworkClauseId);
                if (result) {
                    return [{
                        ...item,  // Copy the parent node properties
                        child: result,  // Include only the matched child
                    }]
                }
            }
        }
    }

    frameworkTree = (frameworkObj) => {
        const arrowIconClass = frameworkObj.expanded ? "arrow-down" : "arrow-right";

        return <div className="dialog-tree-structure-sync">
        {
            !isEmptyVariable(frameworkObj) &&
                <div className="tree-node-sync">
                    <div className="tree-dropdown-layout-sync">
                        <span className={`expand-arrow ${arrowIconClass}`}></span>
                        <TreeNodeDropdown
                            placeholder={frameworkObj.text}
                            description={frameworkObj.description ? frameworkObj.description : ""}
                            dropdownArr={linkArr}
                            labelParam={"label"}
                            className="framework-tree-node"
                            onDropDownItemClick={this.onDropDownItemClick}
                            handleOnClick={() => this.handleVersionClause(frameworkObj)}
                            dropdownId={frameworkObj}
                            fontbold={frameworkObj.fontbold}
                            paraMT={"1.5px"}
                            themeSettings={this.props.themeSettings}
                        />
                    </div>
                </div>
            }
        </div>
    }
    /************************API CALLS **************************/
    getIndexLevelFramework = () => {
        this.setState({
            showLoader:true,
        });
    
        fetch(Constants.GetIndexLevelFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.props.rootFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data.frameworkIndex;
    
                // Convert the object to an array of objects
                const frameworkIndex = temp.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [], // Empty for now; will be populated dynamically
                }));
    
                this.setState({
                    detailFramworkIndex:frameworkIndex,
                    oldDetailFrameworkIndex:frameworkIndex,
                    showLoader:false,
                    componentDidMountFlag:true
                });
            }else{
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }
    
    getChildFramework = (frameworkClauseId) => {
        fetch(Constants.GetChildFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let childData = data.data;
                const childNodes = childData.map(clause => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [],
                }));
                // Add child node inside oldDetailFrameworkIndex array
                const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, childNodes);
                
                // display only selected parent and child node based on click of the right arrow icon
                const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);

                this.setState({ detailFramworkIndex: frameworkIndex });
                
            }else{
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }
    
    getframeworkclause = (frameworkClauseId) => {
        this.setState({
            showLoader:true,
        });
    
        fetch(Constants.GetFrameworkClause,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data;
                const nestedChild = temp.filter(item => item.clauselevel == 1).map(parent => {
                    // Find children of this parent clause
                    const child = temp.filter(child => child.parentClauseId == parent.frameworkClauseId)
                    .map(item => ({
                        ...item,
                        id: item.frameworkClauseId,
                        text: `${item.clauseName}: ${item.heading}`,
                        description: item.description,
                        hasChildren: item.hasChild === 'Y',
                        expanded: false,
                        child: []
                    }));
                    return {
                        ...parent,
                        child
                    };
                })
                // Convert the object to an array of objects
                nestedChild.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: true,
                    child: clause.child,
                }));
                // Add child node inside oldDetailFrameworkIndex array
                const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, nestedChild[0].child);
                // display only selected parent and child node based on click of the right arrow icon
                const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);

                this.setState({
                    detailFramworkIndex:frameworkIndex,
                    showLoader:false
                });
            }else{
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    frameworkLink = () => {
        this.setState({
            showLoader:true,
        });
    
        fetch(Constants.FrameworkLink,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId1:this.props.frameworkId1,
                frameworkClauseId1:this.props.frameworkClauseId1,
                frameworkId2:this.state.frameworkId2,
                frameworkClauseId2:this.state.frameworkClauseId2
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                },()=>{
                    this.props.handleLinkDialogClose(true);
                });
            }else{
                this.setState({
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }
    /************************API CALLS END HERE**************************/

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showLinkDialog} onHide={this.props.handleLinkDialogClose} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.frameworkName}</h5>
                    <button 
                        onClick={this.props.handleLinkDialogClose}
                        type="button" data-dismiss="modal">
                        <span className="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    { 
                        this.state.showLoader && 
                        <div class="loader"></div>
                    }
                    <div className='row custom-row framework-tree-view'>
                        <div className="col-md-12">
                            {this.state.componentDidMountFlag &&
                                !isEmptyArray(this.state.detailFramworkIndex) &&
                                <TreeViewComponent
                                    fields={{
                                        dataSource: this.state.detailFramworkIndex,
                                        id: 'id',
                                        text: 'text',
                                        description: 'description',
                                        hasChildren: 'hasChildren',
                                        expanded: 'expanded',
                                        child: 'child',
                                    }}
                                    cssClass={'custom-framework-tree-node'}
                                    nodeTemplate={this.frameworkTree}
                                    nodeExpanded = {this.nodeDetailExpanded}
                                    nodeCollapsed = {this.nodeDetailCollapsed}
                                    nodeExpanding={this.handleDetailsNodeExpanding}
                                />
                            }
                            {this.state.componentDidMountFlag &&
                                isEmptyArray(this.state.detailFramworkIndex) &&
                                <div class="no-items-layout">
                                    <div class="no-items-card">
                                        <h6>
                                            {Constants.NO_RECORDS_WARNING}
                                        </h6>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        )
    }
}
export default FrameworkLinkClauseDialog;